export default {
    key:'super_admin',
    dashboard: {
        component:'MarketIndex',
        links: {
            sidebar:[
                {
                    icon:'fas fa-fw fa-tachometer-alt',
                    text:'Global Admins',
                    route:'/super_admin',
                    active:'global_admin'
                },
                {
                    icon:'fa fa-user-cog',
                    text:'Settings',
                    route:'/settings',
                    active:'settings'
                }
            ]
        }
    }
}